"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  GO_BACK_TO_REVIEWS: 'GO_BACK_TO_REVIEWS',
  POST_REPLY: 'POST_REPLY',
  FLAG_REVIEW: 'FLAG_REVIEW',
  DELETE_REPLY: 'DELETE_REPLY'
};
exports["default"] = _default;